import React, { useState, useEffect } from "react";

import { listProductBy } from "../function/product";
import ProductCardHome from "../card/ProductCardHome";
import LoadingCard from "../card/LoadingCard";
import "./BestSeller.css";
const NewProduct = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);
    listProductBy("createdAt", "desc", 8)
      .then((res) => {
        setProducts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <div className="bs-wrapper">
      {loading ? (
        <LoadingCard count={3} />
      ) : (
        <div className="bs-scroll">
          {products.map((item, index) => (
            <div key={index} className="bs-item">
              <ProductCardHome product={item} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewProduct;
